module.exports = __webpack_public_path__ + "static/media/sea.63345552.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sea.png
// module id = 186
// module chunks = 0